import { Component, Input, Output, EventEmitter, HostBinding, OnInit, OnDestroy } from '@angular/core';
import { SapiEntityVersion, SapiService } from '../../../services/sapi.service';
import { EntityConfiguration, AbstractDetailsComponent } from '../abstract-details.component';
import { Subscription } from 'rxjs';
import { ReduxService } from '../../../services/redux.service';
import { PublicationService } from '../../../services/publication.service';

@Component({
	selector: 'bb-versions',
	templateUrl: './bb-versions.component.html',
	styleUrls: ['./bb-versions.component.scss']
})

export class BbVersionsComponent implements OnInit, OnDestroy {
	@Input() entityDetails: AbstractDetailsComponent;
	@Input() entityConfiguration: EntityConfiguration;
	@Input() theme = 'light';
	@Output() versionSelected: EventEmitter<any> = new EventEmitter<any>();
	@Output() versionStateSelected: EventEmitter<any> = new EventEmitter<any>();
	@HostBinding('class.dark-theme') get isDarkTheme() {
		return this.theme === 'dark';
	}

	historySubscription: Subscription;
	stateHistory: any[] = [];
	activeState: any;
	entityVersions: SapiEntityVersion[] = [];
	scrollDiv: HTMLElement;

	selectionOptions: any[] = [
		{
			label: 'Draft',
			value: 'working'
		},
		{
			label: 'Published',
			value: 'main'
		}];
	selectedOption: string;
	entityVersionData: any = {};
	loading: boolean;

	constructor(
		private sapiService: SapiService,
		public publicationService: PublicationService,
		protected reduxService: ReduxService
	) {
		this.historySubscription = this.reduxService.historyObs.subscribe((historyData: any) => {
			// timeout to prevent "ExpressionChangedAfterItHasBeenCheckedError"
			setTimeout(() => {
				this.stateHistory = [];
				this.activeState = historyData.present;
				if (historyData && historyData.past) {
					this.stateHistory = [...this.stateHistory, ...historyData.past];
				}
				if (historyData && historyData.present) {
					this.stateHistory = [...this.stateHistory, historyData.present];
				}
				if (historyData && historyData.future) {
					this.stateHistory = [...this.stateHistory, ...historyData.future];
				}
			});
		});
	}

	ngOnInit() {
		if (this.entityConfiguration && this.entityConfiguration.useAutoSave) {
			this.selectionOptions.unshift({
				label: 'Autosaved',
				value: 'autosave'
			});
		}
		if (this.entityConfiguration && this.entityConfiguration.reduxConfig) {
			this.selectionOptions.unshift({
				label: 'Unsaved',
				value: 'local'
			});
		}
		this.selectedOption = this.selectionOptions[0].value;
		this.getVersions();
	}

	getVersions(state = 'allStates', includeMetadata = true) {
		this.loading = true;
		const extra = `versions?${state === 'allStates' ? 'allStates' : 'state=' + state}${includeMetadata ? '&metadata' : ''}`;
		this.sapiService.get(this.entityConfiguration.name, this.entityDetails.activeId, extra).subscribe((data) => {
			this.entityVersionData = data;
			this.setEntityVersions();
			this.loading = false;
		});
	}

	ngOnDestroy() {
		if (this.historySubscription) {
			this.historySubscription.unsubscribe();
		}
	}

	goToState(actionType: string, state?: any) {
		const action: any = {
			type: actionType
		};

		if (state) {
			action.state = state;
		}
		this.reduxService.dispatch(action);
	}

	setScrollDiv(scrollDiv: HTMLElement) {
		if (scrollDiv) {
			this.scrollDiv = scrollDiv;
			this.scrollBottom();
		}
	}

	scrollBottom() {
		setTimeout(() => {
			if (this.scrollDiv) {
				this.scrollDiv.scrollTop = this.scrollDiv.scrollHeight;
			}
		}, 5);
	}

	onFilterClick(option: any) {
		this.selectedOption = option.value;
		if (this.selectedOption !== 'local') {
			this.setEntityVersions();
		}
	}

	setEntityVersions() {
		this.entityVersions = (this.entityVersionData && this.entityVersionData[this.selectedOption]
			&& this.entityVersionData[this.selectedOption].items) || [];
		this.entityVersions = [...this.entityVersions].reverse();
		this.scrollBottom();
	}

	onVersionStateChange(versionState: any) {
		this.versionStateSelected.emit(versionState);
	}

	onVersionClick(version: any) {
		if (this.selectedOption) {
			version.versionState = this.selectedOption;
		}
		this.versionSelected.emit(version);
	}
}
